import {ACTION_TYPE} from '../core/redux/actionType';
import {ApiReducer, makeApiAction, makeApiReducer, RsaaTypes} from '../core/redux/api/reduxStandardApiAction';
import {IAppState} from '../core/redux/IAppState';
import {API_GET_USER} from '../core/redux/api/endpoints';
import {hasTrippedBreaker, updateBreaker} from '../core/redux/api/circuitBreaker/module';
import {addError, addLoading, getLoading, removeLoadingAndError} from '../core/redux/api/module';
import {UserState} from './userState';
import {assoc} from '../language/module';
import { getResource } from '../language/resources/getResource';


export  const ACTIONS = [
  ACTION_TYPE.GET_USER_REQUEST,
  ACTION_TYPE.GET_USER_RESPONSE,
  ACTION_TYPE.GET_USER_ERROR,
];

const KEY_ACTION = ACTION_TYPE.GET_USER_REQUEST;

export const getUserAction = (userId) => makeApiAction(
  {
    method: 'GET',
    headers: (state: IAppState) => ({
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: API_GET_USER(userId),
    types: ACTIONS.map(action => ({type: action})) as RsaaTypes,
    bailout: (state: IAppState) => hasTrippedBreaker(state, ACTION_TYPE.GET_USER_REQUEST)
      || !!getLoading(state, KEY_ACTION, ACTION_TYPE.GET_USER_REQUEST),
  }
);

const reducer: ApiReducer<UserState> = (
  state: IAppState
  , action,
  error,
  isLoading,
  payload
) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error || !payload) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error || getResource(state.locale, 'GET_USER_INFO_ACTION_ERROR'));
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return assoc('userState', payload, noLoadingOrError);
};

export const getUserReducer = makeApiReducer<UserState>(ACTIONS, KEY_ACTION, reducer);